/**
 * SWIPER
 */

// core version + navigation, pagination modules:
import Swiper, {
	Navigation,
	Pagination,
	Thumbs,
	Zoom,
	Autoplay,
} from 'swiper'

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation, Pagination, Thumbs, Zoom])

const carousels = [...document.getElementsByClassName('j-carousel')]

carousels.forEach(function (node) {
	// config
	const swiperConfig = {
		pagination: {
			el: `#${node.id} .swiper-pagination`,
			clickable: true,
		},
		navigation: {
			nextEl: `#${node.id} .swiper-button-next`,
			prevEl: `#${node.id} .swiper-button-prev`,
		},
		watchOverflow: true,
	}

	// Swiper default

	/**
	 * Default
	 *
	 * mobile = r2 x c2
	 * tablet = r1 x c3
	 * desktop = r1 x c4
	 *
	 * Note: to scroll an entire visible page, `slidesPerGroup` = `slidesPerView`
	 */
	new Swiper(`#${node.id} .j-swiper`, {
		...swiperConfig,
		slidesPerView: 2, // cols
		slidesPerGroup: 2,
		slidesPerColumn: 2, // rows
		slidesPerColumnFill: 'row', // note: we need it to use slidesPerColumn
		breakpoints: {
			768: {
				slidesPerView: 3, // cols
				slidesPerGroup: 3,
				slidesPerColumn: 1, // rows
			},
			1024: {
				slidesPerView: 4, // cols
				slidesPerGroup: 4,
				slidesPerColumn: 1, // rows
			},
		},
	})

	/**
	 * Small
	 *
	 * mobile = r1 x c2
	 * desktop = r2 x c1
	 */

	new Swiper(`#${node.id} .j-swiper-small`, {
		...swiperConfig,
		slidesPerView: 2, // cols
		slidesPerGroup: 2,
		slidesPerColumn: 1, // rows
		breakpoints: {
			1024: {
				slidesPerView: 1, // cols
				slidesPerGroup: 1,
				slidesPerColumn: 2, // rows
				slidesPerColumnFill: 'row', // note: we need it to use slidesPerColumn
			},
		},
	})

	/**
	 * Grid
	 *
	 * mobile = r2 x c4
	 * desktop = r2 x c8
	 */

	new Swiper(`#${node.id} .j-swiper-grid`, {
		...swiperConfig,
		slidesPerView: 2, // cols
		slidesPerGroup: 2,
		slidesPerColumn: 2, // rows
		slidesPerColumnFill: 'row', // note: we need it to use slidesPerColumn
		breakpoints: {
			1024: {
				slidesPerView: 4, // cols
				slidesPerGroup: 4,
				slidesPerColumn: 2, // rows
			},
		},
	})

	/**
	 * Highlight
	 *
	 * mobile = r2 x c2
	 * desktop = r2 x c2
	 */

	new Swiper(`#${node.id} .j-swiper-highlight`, {
		...swiperConfig,
		slidesPerView: 2, // cols
		slidesPerGroup: 2,
		slidesPerColumn: 2, // rows
		slidesPerColumnFill: 'row', // note: we need it to use slidesPerColumn
	})

	/**
	 * Banner
	 *
	 * mobile = r1 x c1
	 * desktop = r1 x c1
	 */

	new Swiper(`#${node.id} .j-swiper-banner`, {
		...swiperConfig,
		navigation: false, // TODO: hide navigation does not work properly. This flag disable navigation buttons but does not hide it. Check this.
		loop: true,
		autoplay: {
			delay: 5000,
		},
	})

	// end forEach
})

/**
 * PRODUCT CAROUSEL
 */

const galleryThumbs = new Swiper('.j-product-carousel-thumbs', {
	slidesPerView: 4,
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
})

/* eslint-disable-next-line */
const galleryProduct = new Swiper('.j-product-carousel-gallery', {
	zoom: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'fraction',
	},
	thumbs: {
		swiper: galleryThumbs, // call swiper instance declared before
	},
})
